export default {
  VIEW_APPROVE: "Approve",
  VIEW_REQUEST: "Request",
};
